<div
	class="tabset pb-2"
	[ngClass]="{
		'visually-hidden': hideTabItems
	}"
>
	<div class="row mx-0">
		<div
			*ngFor="let tabItem of tabs(); let first=first; let last=last"
			class="col-auto px-0"
			[ngbTooltip]="tabItem?.tooltipForDisabled"
			[container]="'body'"
			[disableTooltip]="!tabItem.isDisabled()"
			[openDelay]="300"
			[placement]="'auto'"
		>
			<div
				class="item fs-sx col-auto py-2 px-3 mb-2 d-flex justify-content-center align-items-center"
				[ngClass]="{
					'fw-regular': !tabItem?.active,
					'active fw-medium': tabItem?.active,
					'pe-none': tabItem?.isDisabled(),
					'me-2': !last
				}"
				[ngbTooltip]="tabItem?.title"
				[container]="'body'"
				[disableTooltip]="showTitle || tabItem.isDisabled()"
				[openDelay]="300"
				[placement]="'auto'"
				(click)="selectTab(tabItem)"
			>
				<!-- Prepended Template -->
				<ng-container
					*ngIf="tabItem.templateRefPrepended"
					[ngTemplateOutlet]="tabItem.templateRefPrepended"
				></ng-container>

				<!-- Icon -->
				<i
					*ngIf="!tabItem?.svgType && tabItem?.iconClass && showIcon"
					class="icons me-1 fs-md {{ tabItem?.iconClass }}"
				></i>

				<app-svg
					*ngIf="tabItem?.svgType && showIcon"
					class="me-1"
					[size]="svgSizeEnum.SMALL"
					[type]="tabItem?.svgType"
				></app-svg>

				<!-- Title -->
				<span *ngIf="showTitle">
					{{ tabItem?.title }}
				</span>

				<!-- Appended Template -->
				<ng-container
					*ngIf="tabItem.templateRefAppended"
					[ngTemplateOutlet]="tabItem.templateRefAppended"
				></ng-container>
			</div>
		</div>
	</div>
</div>

<ng-container *ngIf="activeTab && !hideTabContent">
	<ng-content></ng-content>
</ng-container>
